import React from 'react';

const CsvPreview = ({ value }) => {
  const parseCsv = (csv) => {
    try {
      const lines = csv.trim().split('\n');
      return lines.map(line => 
        line.split(',').map(cell => cell.trim())
      );
    } catch (error) {
      return [];
    }
  };

  const renderTable = (data) => {
    if (!data || data.length < 2) return null;
    const [headers, ...rows] = data;

    return (
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {headers.map((header, i) => (
              <th 
                key={i} 
                style={{ 
                  border: '1px solid #ddd', 
                  padding: '8px',
                  backgroundColor: '#f8f9fa',
                  position: 'sticky',
                  top: 0
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td 
                  key={j} 
                  style={{ 
                    border: '1px solid #ddd', 
                    padding: '8px',
                    backgroundColor: i % 2 === 0 ? 'white' : '#f8f9fa'
                  }}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div style={{ 
      overflowX: 'auto',
      maxHeight: '400px',
      overflowY: 'auto',
      border: '1px solid #ddd',
      borderRadius: '4px'
    }}>
      {renderTable(parseCsv(value))}
    </div>
  );
};

export default CsvPreview;
